import React, { useState } from 'react';
import './FAQS.css';
import Navbar from '../components/Navbar';
import TopInfoBar from '../components/TopInfoBar';
import BookingSidebar from '../components/BookingSidebar';
import Footer from '../components/Footer';

function FAQS() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  const handleOpenBooking = () => setIsBookingOpen(true);
  const handleCloseBooking = () => setIsBookingOpen(false);

  const faqs = [
    {
      question: "Do you host corporate meetings?",
      answer: "Yes! Hacienda Del Sol Resort offers professional spaces for corporate meetings, team-building events, and company retreats. Our facilities include modern meeting rooms, high-speed Wi-Fi, and full catering services to make your corporate event a success."
    },
    {
      question: "Can I book business meetings at your resort?",
      answer: "Absolutely. Our resort is perfect for business meetings of all sizes. Whether it's a small executive meeting or a larger conference, we provide the amenities and environment to keep your team productive and comfortable."
    },
    {
      question: "Do you host weddings and special events?",
      answer: "Yes! Hacienda Del Sol Resort is a beautiful venue for wedding venues and other celebrations. From intimate ceremonies to grand receptions, we offer customizable packages, stunning views, and experienced event staff to make your special day unforgettable."
    },
    {
      question: "What event spaces are available for booking?",
      answer: "We have a variety of indoor and outdoor spaces suitable for corporate meetings, business meetings, and weddings. Our team can help you select the perfect space based on your guest count and event type."
    },
    {
      question: "Can you provide catering for events?",
      answer: "Yes, catering is available for all events, including corporate meetings, business meetings, and weddings. We offer a wide range of menus to suit your event's style and dietary needs."
    },
    {
      question: "How can I request a quote for an event?",
      answer: "You can easily request a quote by filling out our online form. Provide details about your corporate meeting, business meeting, or wedding, and our team will get back to you promptly with a tailored proposal."
    },
    {
      question: "Are there accommodations for event guests?",
      answer: "Yes! Guests attending corporate meetings, business meetings, or weddings can stay at our resort, ensuring convenience and a comfortable experience throughout their visit."
    },
    {
      question: "What makes Hacienda Del Sol Resort a top choice for events?",
      answer: "Our resort combines stunning scenery, professional event spaces, exceptional service, and flexibility. Whether you're planning corporate meetings, business meetings, or wedding venues, we are dedicated to making your event seamless and memorable."
    }
  ];

  return (
    <div className="faqs-page">
      <TopInfoBar />
      <Navbar onBookNowClick={handleOpenBooking} />
      <section className="faqs-section">
        <div className="faqs-container">
          <div className="faqs-content">
            <h1 className="faqs-title">Frequently Asked Questions</h1>
            <p className="faqs-subtitle">Hacienda Del Sol Resort</p>

            <div className="faqs-list">
              {faqs.map((faq, index) => (
                <div key={index} className="faq-item">
                  <h2 className="faq-question">{faq.question}</h2>
                  <p className="faq-answer">{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <Footer onBookNowClick={handleOpenBooking} />
      <BookingSidebar isOpen={isBookingOpen} onClose={handleCloseBooking} />
    </div>
  );
}

export default FAQS;
